import * as types from './mutation-types.js'
import { INCREMENT_ROOM_TABLE_NUMBER , REMOVE_ROOM_TABLE_NUMBER , ADD_ROOM_TABLE_NUMBER} from '@/store/modules/room/mutation-types'
export const loadTables = ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('/get/tables').then((response) => {
            commit(types.ADD_TABLES, response.data.data)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const loadRestaurantTables = ({ commit, dispatch, state }, restaurant_id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/restaurant/${restaurant_id}/tables`).then((response) => {
            commit(types.LOAD_TABLES, response.data.data)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}
export const loadRoomTables = ({ commit, dispatch, state }, room_id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/room/${room_id}/tables`).then((response) => {
            commit(types.LOAD_TABLES, response.data.data)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const loadTable = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`show/${id}/table`).then((response) => {
            commit(types.LOAD_TABLE, response.data.data)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const storeTable = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('/store/table', data).then((response) => {
            commit(types.ADD_TABLE, response.data.data)
            commit('room/' + INCREMENT_ROOM_TABLE_NUMBER, data.room_id, {root: true})
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const mergeTables = ({ commit, dispatch, state }, { tables, room_id}) => {
    return new Promise((resolve, reject) => {
        window.axios.post('/merge/tables', { tables : tables} ).then((response) => {
            commit('room/' + REMOVE_ROOM_TABLE_NUMBER, { room_id: room_id , count : tables?.length }, {root: true})
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}
export const unmergeTable = ({ commit, dispatch, state }, { table, room_id}) => {
    return new Promise((resolve, reject) => {
        window.axios.post('unmerge/tables', { table : table} ).then((response) => {
            commit('room/' + ADD_ROOM_TABLE_NUMBER, { room_id: room_id , count : response.data.count }, {root: true})
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const attributeTable = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.patch(`attribute/${id}/table`).then((response) => {
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const clearTable = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.patch(`clear/${id}/table`).then((response) => {
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

